import { SxProps } from '@mui/material';

export const tycTypographyStylesSx: SxProps = {
	width: 442,
	height: 18,
};
